import { BrandColor, FontWeight, FunctionColor, TextFontSize, mediaMinWidth } from '@lux/core';
import styled from 'styled-components';
import { Button as LUXButton } from '@lux/buttons';

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const ButtonPlaceholder = styled.div`
    height: 23px;
`;

export const ButtonsWrapper = styled.div`
    margin-top: 10px;
    margin-bottom: 10px;
`;
